import log from '@/helpers/log';
export default class ServerError extends Error {
    constructor(error) {
        log.error('Unhandled error', error);
        const message = 'An unknown error occurred';
        super(message);
    }
}
